import { Component, OnInit, ViewChild } from '@angular/core';
import { OnyxEvent } from '../models/event';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EventStore } from '../service/event.store';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuStore } from '../../menus/service/menu.store';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { Party } from '../models/party';
import { Contact } from '../models/contact';
import { RouteUtils } from '../utils/route-utils';
import { ConfirmationModalComponent } from '../../shared/confirmation-modal/confirmation-modal.component';
import { ConfirmationModalConfig } from '../../shared/confirmation-modal/confirmation-modal-config';
import { TranslateService } from '@ngx-translate/core';
import { EventSearchParametersStore } from '../service/event-search-parameters.store';
import { PaymentStore } from '../service/payment.store';
import { of } from 'rxjs/observable/of';
import { RatePlanCode } from '../models/rate-plan-code';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { User } from 'app/auth/models/User';
import { MultiAgency } from 'app/shared/models/multi-agency';
import { UserLocalStorageService } from 'app/permission/services/user.local.storage.service';
import { MultiAgencyService } from 'app/shared/multi-agency/multi-agency.service';
import { MergeMatchInfo } from '../models/merge-match-info';
import { MatchingPropertyStore } from '../service/matching-property.store';
import { EventCollisionMatch } from '../models/event-collision-match';
import { EventCollisionModalComponent } from 'app/shared/event-collision-modal/event-collision-modal.component';
import { EventCollisionModalConfig } from 'app/shared/event-collision-modal/event-collision-modal-config';
import { PartyType } from '../models/party-type';
import { isNullOrUndefined } from 'util';
import { EventUtils } from '../utils/event-utils';
import { EventMatchLogStore } from '../service/event-match-log.store';
import { EventMatchLog } from '../models/event-match-log';
import { UnmatchEventPopupComponent } from '../unmatch-event-popup/unmatch-event-popup.component';
import { UnmatchEventRequest } from '../models/unmatch-event-request';
import { UnmatchEventPartyRequest } from '../models/unmatch-event-party-request';
import { RsvpStore } from '../service/rsvp.store';
import { ReservationStore } from '../service/reservation-store';
import { EventValidationService } from '../service/event-validation.service';
import { AgencyLookupStore } from '../../shared/lookup/agency-lookup/agency-lookup.store';
import { MergeEventRequest } from '../models/merge-event-request';
import { GuidGeneratorStore } from '../service/guid-generator.store';
import { EventCollisionModalResponseEnum } from 'app/shared/event-collision-modal/event-collision-modal-response.enum';
import { Subject } from 'rxjs/Subject';
import {
  EventCollisionModalMultipromptComponent
} from 'app/shared/event-collision-modal-multiprompt/event-collision-modal-multiprompt.component';
import { EventCollisionModalResponse } from 'app/shared/event-collision-modal/event-collision-modal-response';
import { EventInfoForEventCollision } from '../models/event-info-for-event-collision';
import { PaymentStatus } from '../models/payment-status.enum';
import { catchError, map, switchMap } from 'rxjs/operators';
import { LogService } from '../../shared/log/log.service';
import { MatchingAgencyService } from '../../shared/matching-agency/matching-agency.service';

@Component({
  selector: 'pioneer-event',
  templateUrl: './event.component.html'
})
export class EventComponent implements OnInit {
  public eventForm: FormGroup;

  public onyxEvent: OnyxEvent;
  public savedEventSerialized: string;

  public isReadOnly = true;

  private user: User;

  public clientContactEditable = true;

  public propertyEmail: string;

  public agencyEmail: string;

  hasFinalPayment: boolean;

  hasEventRsvp: boolean;

  hasEventReservation: boolean;

  hasEventPayment: boolean;

  hasSubscriberAgency: boolean;

  isEventLockdown: boolean;

  isRequestedOrRequestResentOrRejected: boolean;

  matchingEndPointConfig: any;

  eventMatches: EventMatchLog[] = [];

  temporaryGuid: string;
  eventMatchInfo: Array<MergeMatchInfo> = [];
  eventCollisionMatches = new Map();

  focusEventNameSubject = new Subject();

  public formModelToMerge: any;

  @ViewChild(EventCollisionModalComponent)
  eventCollisionModal: EventCollisionModalComponent;
  public eventCollisionModalConfig = new EventCollisionModalConfig();

  @ViewChild(EventCollisionModalMultipromptComponent)
  eventCollisionModalMultiprompt: EventCollisionModalMultipromptComponent;

  @ViewChild('confirmDeleteModal')
  confirmDeleteModal: ConfirmationModalComponent;

  @ViewChild('confirmUnmatchModal')
  confirmUnmatchModal: ConfirmationModalComponent;

  @ViewChild(UnmatchEventPopupComponent)
  unmatchEventModal: UnmatchEventPopupComponent;

  confirmationModalConfig = new ConfirmationModalConfig();

  removedVendors: Party[] = [];

  get propertyUserEventParty() {
    return this.authenticationStore.isPropertyUser() ? this.onyxEvent.eventProperty : undefined;
  }

  canEditContractSummary$: Observable<boolean>;
  canEditAgencyContact$: Observable<boolean>;
  canEditClientContact$: Observable<boolean>;

  get isDirty() {
    if (!this.eventForm) {
      return false;
    }
    if (this.eventForm.disabled) {
      return false;
    }
    if (this.eventForm.dirty) {
      return true;
    }
    if (EventUtils.serializeEvent(this.onyxEvent) !== this.savedEventSerialized) {
      return true;
    }
    return this.isSelectedAgency;
  }

  isSelectedAgency = false;

  paymentStatus: PaymentStatus;

  constructor(public router: Router,
              private eventStore: EventStore,
              private formBuilder: FormBuilder,
              private menuStore: MenuStore,
              private flashMessagesService: FlashMessagesService,
              private translateService: TranslateService,
              private route: ActivatedRoute,
              private eventSearchParametersStore: EventSearchParametersStore,
              private paymentStore: PaymentStore,
              private authenticationStore: AuthenticationStore,
              private userLocalStorageService: UserLocalStorageService,
              private multiAgencyService: MultiAgencyService,
              private matchingPropertyStore: MatchingPropertyStore,
              private eventMatchLogStore: EventMatchLogStore,
              private rsvpStore: RsvpStore,
              private reservationStore: ReservationStore,
              private eventValidationService: EventValidationService,
              private agencyLookupStore: AgencyLookupStore,
              private guidGeneratorStore: GuidGeneratorStore,
              private matchingAgencyService: MatchingAgencyService,
              private logService: LogService) {
  }

  ngOnInit() {
    this.menuStore.setPageHeader('EVENT.EVENT_INFO_TITLE', false);
    this.menuStore.setIsReadOnly(true);

    this.authenticationStore.user.subscribe((user: User) => {
      this.user = user;
    });

    this.onyxEvent = new OnyxEvent();
    this.eventStore.selectedEvent.subscribe(value => {
      this.onyxEvent = new OnyxEvent(value);
      if (!this.savedEventSerialized) {
        this.savedEventSerialized = EventUtils.serializeEvent(this.onyxEvent);
      }
      if (this.authenticationStore.isSupportUser() && this.onyxEvent.eventId) {
        this.eventMatchLogStore.getMatchesByEvent(this.onyxEvent.eventId).subscribe((data) => {
          this.eventMatches = data;
        });
      } else {
        this.eventMatches = [];
      }
    });

    this.menuStore.isReadOnly.subscribe(isReadOnly => {
      this.isReadOnly = isReadOnly;
    });

    if (EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser())) {
      this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser()),
        this.onyxEvent.eventProperty.subscriber);
    }
    if (!isNullOrUndefined(this.onyxEvent.eventProperty)
    && !isNullOrUndefined(this.onyxEvent.eventProperty.contact)
    && !isNullOrUndefined(this.onyxEvent.eventProperty.contact.email)) {
      this.propertyEmail = this.onyxEvent.eventProperty.contact.email;
    }
    if (!isNullOrUndefined(this.onyxEvent.eventAgency)
    && !isNullOrUndefined(this.onyxEvent.eventAgency.contact)
    && !isNullOrUndefined(this.onyxEvent.eventAgency.contact.email)) {
      this.agencyEmail = this.onyxEvent.eventAgency.contact.email;
    }
    this.eventForm = this.formBuilder.group({
      'event': this.formBuilder.group({
        'eventAgency': this.formBuilder.group({}),
        'eventClient': this.formBuilder.group({}),
        'eventProperty': this.formBuilder.group({}),
        'eventVendors': this.formBuilder.array([])
      })

    });

    // toggle page to editable if the URL ends with "edit" (it will default to read only)
    // otherwise, check if we need to show a warning flash message when in view modeFD
    RouteUtils.getLastUrlSegment(this.route)
      .subscribe(lastSegment => {
        if (lastSegment && lastSegment.path === 'edit') {
          this.togglePageToReadOnly(false);
        }
      });
    if (!this.onyxEvent.eventId || isNullOrUndefined(this.onyxEvent.eventProperty.eventPartyId)) {
      this.hasFinalPayment = false;
      this.isRequestedOrRequestResentOrRejected = false;
      this.isEventLockdown = false;
    } else {
      this.paymentStore.getLatestVendorFinalPayments().take(1).subscribe(lastFinalPayment => {
        this.hasFinalPayment = Boolean(this.hasFinalPayment || (lastFinalPayment && lastFinalPayment.length > 0));
        if (this.hasFinalPayment) {
          this.paymentStatus = lastFinalPayment[0].status;
        }
      });

      this.paymentStore.isLastVendorPaymentRequestedOrRequestResentOrRequestRejected(this.onyxEvent.eventProperty.eventPartyId)
      .subscribe(isReqOrReqResentOrRej => {
        this.isRequestedOrRequestResentOrRejected = isReqOrReqResentOrRej;
      });

      this.paymentStore.isEventPropertyLockdown(this.onyxEvent.eventProperty.eventPartyId).subscribe(isEventLockdown => {
        if (!isEventLockdown) {
          this.isEventLockdown = false;
        } else {
          this.isEventLockdown = isEventLockdown;
        }
      });

    }

    this.authenticationStore.clientContactEditable$.subscribe(value => {
      this.clientContactEditable = value;
    });

    this.hasEventRsvpSubscribe();
    this.hasEventReservationSubscribe();
    this.hasEventPaymentSubscribe();
    this.hasSubscriberAgencySubscribe();

    this.canEditContractSummary$ = this.eventValidationService.canEditContractSummary();
    this.canEditAgencyContact$ = this.eventValidationService.canEditAgencyContact();
    this.canEditClientContact$ = this.eventValidationService.canEditClientContact();

    this.guidGeneratorStore.generateGuid('EV').subscribe((value) => {
      this.temporaryGuid = value;
    });

    this.eventMatchInfo = [];
    this.eventCollisionMatches = new Map();
  }

  onSaveBtn(model: any): Observable<any> {
    const runMatchingAgency = Boolean(
      this.authenticationStore.isPropertyUser()
      && model.eventAgency
      && model.eventAgency.code
      && model.eventProperty.chain
      && model.eventAgency.newTravelAgency);

    // Matching Agency result may update the current model
    const finalModel$ = this.matchingAgencyService.matchingAgencyProcess(model, runMatchingAgency);

    // Once the final model is resolved, event collision process is invoked.
    const eventCollision$ = finalModel$.pipe(
      map((finalModel: any) => {
        let info: EventInfoForEventCollision = {
          event: finalModel.event,
          eventProperties: this.authenticationStore.isPropertyUser() ? [finalModel.eventProperty] : this.getPropertiesFromModel(finalModel),
          eventAgency: finalModel.eventAgency,
          eventClient: finalModel.eventClient
        };
        return info;
      }),
      switchMap((info: EventInfoForEventCollision) =>
        this.eventCollisionProcess(info)
      )
    );
    eventCollision$.subscribe();

    return eventCollision$;
  }

  save(model: any): Observable<OnyxEvent> {
    this.eventForm.disable();
    model.eventProperty = this.getEventProperty(model);
    model.event.propertyId = model.eventProperty.propertyId;
    model.event.eventAgency = model.eventAgency;
    model.event.eventClient = model.eventClient;
    model.event.eventProperty = model.eventProperty;
    model.event.eventVendors = this.getVendorsFromModel(model);

    if (!this.isMultiVendor()) {
      if (!model.event.eventProperty.commRetention) {
        model.event.eventProperty.commRetention = model.event.commRetention;
      }
      if (!this.hasFinalPayment || this.paymentStatus === PaymentStatus.REJECTED_WF_APPROVAL) {
        model.event.eventProperty.commissionRoomPercentage = model.event.commissionRoomPercentage;
      }
    }

    let formModel = Object.assign({}, this.onyxEvent.toJS(), model.event);
    const updatedFields: Object = {};

    if (formModel.eventAgency) {
      const eventAgency = this.onyxEvent.eventAgency || new Party({ contact: new Contact() });
      updatedFields['eventAgency'] = Object.assign({}, eventAgency, model['eventAgency']);
      updatedFields['eventAgency']['contact'] = Object.assign({}, eventAgency.contact, model['eventAgency']['contact']);
    }

    if (formModel.eventClient) {
      const eventClient = this.onyxEvent.eventClient || new Party({ contact: new Contact() });
      updatedFields['eventClient'] = Object.assign({}, eventClient, model['eventClient']);
      updatedFields['eventClient']['contact'] = Object.assign({}, eventClient.contact, model['eventClient']['contact']);
    }

    if (formModel.eventProperty) {
      const eventProperty = this.onyxEvent.eventProperty || new Party({ contact: new Contact() });
      updatedFields['eventProperty'] = Object.assign({}, eventProperty, model['eventProperty']);
      updatedFields['eventProperty']['contact'] = Object.assign({}, eventProperty.contact, model['eventProperty']['contact']);
    }

    let _startDate: string;
    let _endDate: string;
    let _eventName: string;
    if (model.event.startDate) {
      _startDate = new Date(model.event.startDate).toISOString();

      if (this.authenticationStore.isAgencyUser()) {
        updatedFields['eventAgency']['startDate'] = _startDate;
      } else {
        updatedFields['eventProperty']['startDate'] = _startDate;
      }

      this.updatePartyDate(updatedFields, 'eventProperty', 'startDate', _startDate);
      this.updatePartyDate(updatedFields, 'eventAgency', 'startDate', _startDate);
    }
    if (model.event.endDate) {
      _endDate = new Date(model.event.endDate).toISOString();

      if (this.authenticationStore.isAgencyUser()) {
        updatedFields['eventAgency']['endDate'] = _endDate;
      } else {
        updatedFields['eventProperty']['endDate'] = _endDate;
      }

      this.updatePartyDate(updatedFields, 'eventProperty', 'endDate', _endDate);
      this.updatePartyDate(updatedFields, 'eventAgency', 'endDate', _endDate);
    }
    if (model.event.name) {
      _eventName = model.event.name;

      if (this.authenticationStore.isAgencyUser()) {
        updatedFields['eventAgency']['partyEventName'] = _eventName;
      } else {
        updatedFields['eventProperty']['partyEventName'] = _eventName;
      }

      this.updatePartyDate(updatedFields, 'eventProperty', 'partyEventName', _eventName);
      this.updatePartyDate(updatedFields, 'eventAgency', 'partyEventName', _eventName);
    }

    if (formModel.eventVendors && formModel.eventVendors !== undefined) {
      let updatedVendors = [];
      for (let i = 0; i < formModel.eventVendors.length; i++) {
        if (formModel.eventVendors[i] && formModel.eventVendors[i] !== undefined) {
          let updatedVendor;
          const eventVendor = this.onyxEvent.eventVendors[i] || new Party({ contact: new Contact() });
          if (formModel.eventVendors[i].partyType  === PartyType.PROPERTY && formModel.eventVendors[i].payorType === 'PROPERTY') {
            updatedFields['brand'] = formModel.eventVendors[i].brand;
            updatedFields['chain'] = formModel.eventVendors[i].chain;
            updatedFields['propertyId'] = formModel.eventVendors[i].propertyId;
          }
          const formName = 'eventVendor-' + this.getVendorCode(eventVendor);
          updatedVendor = Object.assign({}, eventVendor, model[formName]);
          updatedVendor['contact'] = Object.assign({}, eventVendor.contact, model[formName]['contact']);

          if (!updatedVendor.startDate && model.event.startDate) {
            updatedVendor.startDate =  _startDate;
          }
          if (!updatedVendor.endDate && model.event.endDate) {
            updatedVendor.endDate =  _endDate;
          }
          if (!updatedVendor.partyEventName && model.event.name) {
            updatedVendor.partyEventName =  _eventName;
          }

          updatedVendors.push(updatedVendor);
        }
      }
      updatedFields['eventVendors'] = updatedVendors;
    }

    // checks if the user did not click the add button
    if (model.event.ratePlanCode) {
      formModel.ratePlanCodes.push(new RatePlanCode({ ratePlanCode: model.event.ratePlanCode }));
    }

    const updatedModel = new OnyxEvent(Object.assign({}, formModel, updatedFields));

    if (formModel.eventClient) {
      updatedModel.eventClient.code = formModel.eventClient.code;
    }

    let partiesForUnmatching = [];
    if (this.authenticationStore.isAgencyUser() && this.removedVendors && this.removedVendors.length > 0) {
      this.removedVendors.forEach((vendor: any) => {
        if (this.isRemovedVendor(vendor, updatedModel.eventVendors) && vendor.mergedEvent === 'Y') {
          partiesForUnmatching.push(vendor);
        }
      });
    }

    let returnedEvent;
    if (this.eventCollisionMatches.size > 0 || partiesForUnmatching.length > 0) {
      let eventInfo = [];
      this.eventCollisionMatches.forEach(function(value, key) {
        eventInfo.push(value);
      });
      let partyInitiatorType = null;
      let partyInitiatorCode = null;
      if (this.authenticationStore.isPropertyUser()) {
        partyInitiatorType = updatedModel.eventProperty.partyType.toString();
        partyInitiatorCode = updatedModel.eventProperty.code;
      } else {
        partyInitiatorType = updatedModel.eventAgency.partyType.toString();
        partyInitiatorCode = updatedModel.eventAgency.code;
      }
      const mergeRequest: MergeEventRequest = new MergeEventRequest({
        action: 'ADD_EVENT',
        user_id: this.user.username,
        party_initiator_type: partyInitiatorType,
        party_initiator_code: partyInitiatorCode,
        merge_info: eventInfo,
        event: updatedModel,
        ev_tmp_guid: this.temporaryGuid,
        parties_for_unmatching: partiesForUnmatching
      });
      returnedEvent = this.sendMergeMatchingRequest(mergeRequest);
    } else {
      const finalUpdatedModel = updatedModel.merge({'evTmpGuid': this.temporaryGuid}) as OnyxEvent;
      if (this.authenticationStore.isPropertyUser()) {
        finalUpdatedModel.eventProperty.eventReferenceNumber = formModel.eventReferenceNumber;
        if (finalUpdatedModel.eventProperty) {
          finalUpdatedModel.eventProperty.ratePlanCodes = finalUpdatedModel.ratePlanCodes;
        }
        returnedEvent = this.eventStore.updateEvent(finalUpdatedModel);
      } else {
        finalUpdatedModel.eventAgency.eventReferenceNumber = formModel.eventReferenceNumber;
        returnedEvent = this.eventStore.updateAgencyEvent(finalUpdatedModel);
      }
    }

    returnedEvent.subscribe(
      (res) => {
        let changeIata = false;
        if (this.user && this.user.allArcIatas && this.user.customerInfo && this.user.customerInfo.length >= 2) {
          const key = this.user.username.toUpperCase() + AuthenticationStore.CURRENT_AGENCY_STR;
          const currentAgency = JSON.parse(this.userLocalStorageService.getItem(key));
          if (currentAgency.agencyId !== updatedModel.eventAgency.code) {
            changeIata = true;
          }
        }

        if (changeIata) {
          const agency: MultiAgency = new MultiAgency({
            agencyId: updatedModel.eventAgency.code,
            agencyName: updatedModel.eventAgency.name
          });
          this.authenticationStore.updateIataFromToken(agency.agencyId).subscribe(() => {
            this.multiAgencyService.setAgencySelectedUI(true);
            this.multiAgencyService.setDefaultAgency(agency);
            if (this.isMultiVendor()) {
              this.router.navigate(['/event', res.eventId, 'summary']);
            } else {
              this.router.navigate(['/event', res.eventId, res.eventProperty.eventPartyId, 'summary']);
            }

          });
        } else {
          if (this.isMultiVendor()) {
            this.router.navigate(['/event', res.eventId, 'summary']);
          } else {
            this.router.navigate(['/event', res.eventId, res.eventProperty.eventPartyId, 'summary']);
          }
        }
      },
      error => {
        this.eventForm.enable();
        if (error.includes('Agency Event Reference Number already exists')) {
          this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_DUPLICATED_AGENCY_REFERENCE_NUMBER', error);
        } else if (error.includes('Property Event Reference Number already exists')) {
          this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_DUPLICATED_PROPERTY_REFERENCE_NUMBER', error);
        } else if (error.includes('The event must have one payor-type hotel')) {
          this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_NO_PAYOR_TYPE_HOTEL', error);
        } else if (error.includes('The event must have only one payor-type hotel')) {
          this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_ONLY_ONE_PAYOR_TYPE_HOTEL', error);
        } else if (error.includes('Legal Entity data is missing')) {
          this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_LEGAL_ENTITY_DATA_IS_MISSING', error);
        } else if (error.includes('Invalid Tax ID')) {
          this.flashMessagesService.error('MESSAGES.ERROR.INVALID_VAT_ID', error);
        } else {
          this.flashMessagesService.error('MESSAGES.ERROR.UPDATE_EVENT', error);
        }
      });

    return returnedEvent;
  }

  edit(): void {
    this.savedEventSerialized = undefined;
    if (this.isMultiVendor()) {
      this.router.navigate(['/event', this.onyxEvent.eventId, 'summary', 'edit']);
    } else {
      this.router.navigate(['/event', this.onyxEvent.eventId, this.onyxEvent.eventProperty.eventPartyId, 'summary', 'edit']);
    }
  }

  confirmBeforeDeleting() {
    // set up the title of the confirmation modal
    const label = 'EVENT.DELETE_EVENT';
    this.confirmationModalConfig.title = this.translateService.instant(label);

    this.confirmDeleteModal.open();
  }

  confirmBeforeDeletingHandler(value: any) {
    if (value) {
      const eventId = this.onyxEvent.eventId;
      this.delete();
    }
  }

  get canBeDeleted(): boolean {
    return this.onyxEvent.canBeDeleted;
  }

  delete(): void {
    this.eventForm.disable();
    this.eventStore.deleteEvent(this.onyxEvent.eventId).subscribe(() => {
      this.eventSearchParametersStore.updateUrl();
    }, () => {
      this.eventForm.enable();
    });
  }

  cancel(): void {
    this.eventForm.disable();
    if (this.isMultiVendor()) {
      this.router.navigate(['/event', this.onyxEvent.eventId, 'summary']);
    } else {
      this.router.navigate(['/event', this.onyxEvent.eventId, this.onyxEvent.eventProperty.eventPartyId, 'summary']);
    }
    this.reset();
  }

  reset() {
    if (this.isMultiVendor()) {
      this.eventStore.getEvent(this.onyxEvent.eventId)
        .take(1)
        .subscribe(event => {
          this.onyxEvent = new OnyxEvent(event);
      });
    } else {
      this.eventStore.getEventByParty(this.onyxEvent.eventId, this.onyxEvent.eventProperty.eventPartyId)
        .take(1)
        .subscribe(event => {
          this.onyxEvent = new OnyxEvent(event);
      });
    }
  }

  togglePageToReadOnly(readOnly: boolean): void {
    const name = EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser());
    if (name) {
      this.menuStore.setPageHeader(readOnly ? name : 'Edit - ' + name,
        this.onyxEvent.eventProperty.subscriber);
    } else {
      this.menuStore.setPageHeader(readOnly ? 'EVENT.EVENT_INFO_TITLE' : 'EVENT.TITLE_EDIT', false);
    }

    this.menuStore.setIsReadOnly(readOnly);
  }

  setupPropertyEmail(email: string): void {
    this.propertyEmail = email;
  }

  setupAgencyEmail(email: string): void {
    this.agencyEmail = email;
  }

  get hideEditButton(): boolean {
    return !this.showEditButton();
  }

  private showEditButton(): boolean {
    if (this.isMultiVendor()) {
      return true;
    }
    if (this.authenticationStore.isPropertyUser()) {
      if (!this.hasFinalPayment || this.paymentStatus === PaymentStatus.REJECTED_WF_APPROVAL) {
        return true;
      }
    }
    return false;
  }

  getVendorsFromModel(model: any) {
    let vendors = [];

    this.onyxEvent.eventVendors.forEach(function (vendor) {
      const vendorCode = vendor.code ? vendor.code : vendor.chain + '|' + vendor.brand + '|' + vendor.propertyId;
      vendors.push(model['eventVendor-' + vendorCode]);
    });

    return vendors;
  }

  getEventProperty(model: any) {
    let property = {};
    if (this.isMultiVendor()) {
      this.onyxEvent.eventVendors.forEach(function (vendor) {
        if (vendor.partyType  === PartyType.PROPERTY && vendor.payorType === 'PROPERTY') {
          property = vendor;
        }
      });
    } else {
      return model.eventProperty;
    }
    return property;
  }

  getVendorCode(vendor): string {
    return vendor.code ? vendor.code : vendor.chain + '|' + vendor.brand + '|' + vendor.propertyId;
  }

  isMultiVendor() {
    return this.authenticationStore.hasPermission('MultiVendor');
  }

  get isSingleVendor(): boolean {
    return this.authenticationStore.hasPermission('SingleVendor');
  }

  public confirmBeforeSaveEventHandler(response: EventCollisionModalResponse) {
    if (response.selectedButton === EventCollisionModalResponseEnum.MergeEvents) {
      this.eventMatchInfo.forEach((item: any) => {
        if (response.selectedMatches.indexOf(item.event_match_id) > -1) {
          let key = item['create_party'] === 'PROPERTY' ? item['matched_agency_id'] : item['matched_vendor_code'];
          this.eventCollisionMatches.set(key, item);
        }
      });
    }
    this.eventMatchInfo = [];
    this.save(this.eventForm.value);
  }

  cancelMatchingWizard(response: EventCollisionModalResponse) {
    let matchesToCancel = [];
    this.eventMatchInfo.forEach((item: any) => {
      if (response.selectedMatches.indexOf(item.event_match_id) === -1) {
        matchesToCancel.push(item.event_match_id);
      }
    });
    const obs = this.matchingPropertyStore
      .cancelMatching(matchesToCancel)
      .take(1)
      .catch((error) => {
        return Observable.throw(error);
      }).finally(() => {
        this.eventMatchInfo = [];
        this.eventForm.enable();
        this.focusEventNameSubject.next();
      });
    obs.subscribe();
    return obs;
  }

  eventCollisionProcess(info: EventInfoForEventCollision) {
    let obs = this.invokeEventCollisionMatching(info);
    obs.subscribe((match) => {
      if (match) {
        if (this.anyMatchFound(match)) {
          let matchesForModalPanel = [];
          let propertiesFromModalPanel = [];
          match.forEach((item: any) => {
            if (item.result === 'fuzzy') {
              this.eventMatchInfo.push(new MergeMatchInfo({
                create_party: item.create_party,
                id: item.id,
                merge_event: true,
                source: 'Manual input',
                event_match_id: item.event_match_id,
                matched_event_id: item.matches[0].event_id,
                matched_agency_id: item.matches[0].agency_id,
                matched_vendor_code: item.matches[0].vendor_code,
                edited_event_id: item['edited_event_id'],
                edited_agency_id: item['edited_agency_id'],
                edited_vendor_code: item['edited_vendor_code'],
                action: item['action'],
                user_id: item['user_id'],
                ev_tmp_guid: item['ev_tmp_guid']
              }));
              matchesForModalPanel.push(item);
              propertiesFromModalPanel.push(`${item.property_name} ${item.property_address}`);
            }
          });
          const eventMatch = new EventCollisionMatch({
            createdBy: this.authenticationStore.isPropertyUser() ? info.eventProperties[0].name :
                                                                   info.eventAgency.name,
            clientCompany: info.eventClient.name ? info.eventClient.name : '',
            eventName: info.event.name,
            groupCode: info.event.eventReferenceNumber,
            startDate: info.event.startDate,
            endDate: info.event.endDate,
            property: matchesForModalPanel.length > 1 ? '' : propertiesFromModalPanel[0],
            eventMatchId: matchesForModalPanel.length > 1 ? null : matchesForModalPanel[0].event_match_id,
          });
          if (matchesForModalPanel.length > 1) {
            this.eventCollisionModalMultiprompt.open(eventMatch, matchesForModalPanel);
          } else {
            this.eventCollisionModal.open(eventMatch, matchesForModalPanel[0].matches[0]);
          }
        } else {
          return this.save(this.eventForm.value);
        }
      }
      return match;
    });
    return obs;
  }

  invokeEventCollisionMatching(info: EventInfoForEventCollision): Observable<any> {
    let returnedEvent = this.matchingPropertyStore
      .getMatchingCollisionProperties(info, info.event.eventId, this.user.username, this.temporaryGuid)
      .catch((error) => {
        this.flashMessagesService.error('MESSAGES.ERROR.MATCHING_EVENT', error);
        return Observable.throw(error);
      })
      .map((res) => {
        return res;
      });
    return returnedEvent;
  }

  sendMergeMatchingRequest(eventInfo: any): Observable<any> {
    let returnedEvent = this.matchingPropertyStore
      .updateEventCollisionMatch(eventInfo)
      .catch((error) => {
        this.eventForm.enable();
        if (error.includes('Agency Event Reference Number already exists')) {
          this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_DUPLICATED_AGENCY_REFERENCE_NUMBER', error);
        } else if (error.includes('Property Event Reference Number already exists')) {
          this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_DUPLICATED_PROPERTY_REFERENCE_NUMBER', error);
        } else if (error.includes('The event must have one payor-type hotel')) {
          this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_NO_PAYOR_TYPE_HOTEL', error);
        } else if (error.includes('The event must have only one payor-type hotel')) {
          this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_ONLY_ONE_PAYOR_TYPE_HOTEL', error);
        } else {
          this.flashMessagesService.error('MESSAGES.ERROR.MERGE_MATCHING_EVENT', error);
        }
        return Observable.throw(error);
      })
      .map((res) => {
        this.eventStore.setEvent(res);
        return res;
      });
    return returnedEvent;
  }

  private getEventName(event: OnyxEvent) {
    return EventUtils.getEventName(event, this.authenticationStore.isAgencyUser());
  }

  private getStartDate(event: OnyxEvent) {
    return EventUtils.getEventStartDate(event, this.authenticationStore.isAgencyUser());
  }

  private getEndDate(event: OnyxEvent) {
    return EventUtils.getEventEndDate(event, this.authenticationStore.isAgencyUser());
  }

  private updatePartyDate(updatedFields: Object, partyType: string, dateType: string, date: string) {
    if (updatedFields[partyType] && !updatedFields[partyType][dateType]) {
      updatedFields[partyType][dateType] = date;
    }
  }
  get canBeUnmatched(): Observable<boolean> {
    // ME-13128: Hide "Unmatch" button for Support users
    return Observable.of(false);
    // ME-10716: Rollback a match - Support user button
    // return of(Boolean(this.authenticationStore.isSupportUser() && this.onyxEvent.canBeUnmatched));
  }

  unmatch(): void {
    if (this.authenticationStore.isSupportUser() && this.eventMatches.length > 0) {
      if (this.eventMatches.length === 1) {
        const label = 'EVENT.UNMATCH_EVENT';
        this.confirmationModalConfig.title = this.translateService.instant(label);
        this.confirmUnmatchModal.open();
      } else {
        this.unmatchEventModal.open();
      }
    }
  }

  confirmBeforeUnmatchingHandler(value: any) {
    if (value) {
      let parties: UnmatchEventPartyRequest[] = [];
      const party: UnmatchEventPartyRequest = new UnmatchEventPartyRequest({
        type: this.eventMatches[0].matchPartyType,
        code: this.eventMatches[0].matchPartyCode
      });
      parties.push(party);
      const unmatchEventRequest: UnmatchEventRequest = new UnmatchEventRequest({
        action: (parties[0].type === 'AGENCY' ? 'UNMATCH_AGENCY' : 'UNMATCH_VENDOR'),
        event_id: this.onyxEvent.eventId,
        parties: parties,
        reason: '',
        unmatched_by: null,
        party_initiator_type: null,
        party_initiator_code: null,
        event_info: null,
      });
      this.invokeUnmatchEvent(unmatchEventRequest);
    }
  }

  public confirmUnmatchPopupHandler(unmatchInfo: any) {
    this.invokeUnmatchEvent(unmatchInfo);
  }

  invokeUnmatchEvent(unmatchEventRequest: any) {
    let returnedEvent = this.matchingPropertyStore.unmatchEvent(unmatchEventRequest);
    this.eventForm.disable();
    returnedEvent.subscribe(
      (response) => {
        this.router.navigate(['/event', response['new_event_id'], 'summary']);
      },
      error => {
        this.eventForm.enable();
        this.flashMessagesService.error('MESSAGES.ERROR.UNMATCH_EVENT', error);
      }
    );
  }

  public get isNotEventEditable(): Observable<boolean> {
    const isMultiVendorUserOrAgencyCreatedEvent =
      (this.isMultiVendor() || (this.onyxEvent.eventAgency && this.onyxEvent.eventAgency.createdEvent === 'Y'));

    const hasRsvpOrReservationOrPayment = this.hasEventRsvp || this.hasEventReservation || this.hasEventPayment;

    const isSubscriberAgencyCase = !this.isMultiVendor() && this.hasSubscriberAgency && !this.hasEventPayment;

    return of(Boolean(isMultiVendorUserOrAgencyCreatedEvent && hasRsvpOrReservationOrPayment && !isSubscriberAgencyCase));
  }

  private hasEventRsvpSubscribe(): void {
    this.rsvpStore.getEventHasRsvps().take(1).subscribe(eventHasRsvps => {
      this.hasEventRsvp = eventHasRsvps;
    });
  }

  private hasEventReservationSubscribe(): void {
    this.reservationStore.getEventHasReservations().take(1).subscribe(hasReservations => {
      this.hasEventReservation = hasReservations;
    });
  }

  private hasEventPaymentSubscribe(): void {
    this.paymentStore.payments.take(1).subscribe(payments => {
      this.hasEventPayment = Boolean(payments && payments.size > 0);
    });
  }

  private hasSubscriberAgencySubscribe(): void {
    if (this.onyxEvent.eventAgency) {
      this.agencyLookupStore.isSubscriberAgency(this.onyxEvent.eventAgency.code).take(1).subscribe(isSubscriber => {
        this.hasSubscriberAgency = Boolean(isSubscriber);
      });
    }
  }

  get isMultiVendorUserAndEventCreatedByProperty (): boolean {
    return this.isMultiVendor()
      && this.onyxEvent.eventVendors
      && this.onyxEvent.eventVendors
        .find(vendor => vendor.payorType === 'PROPERTY' && vendor.subscriber && vendor.createdEvent === 'Y') != null
      && this.onyxEvent.eventAgency
      && this.onyxEvent.eventAgency.createdEvent !== 'Y';
  }

  get isSingleVendorUserAndEventCreatedByAgency (): boolean {
    return this.isSingleVendor
      && this.onyxEvent.eventAgency
      && this.onyxEvent.eventAgency.createdEvent !== 'Y';
  }

  getPropertiesFromModel(model: any) {
    let vendors = [];

    this.onyxEvent.eventVendors.forEach(function (vendor) {
      if (vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY') {
        const vendorCode = vendor.code ? vendor.code : vendor.chain + '|' + vendor.brand + '|' + vendor.propertyId;
        vendors.push(model['eventVendor-' + vendorCode]);
      }
    });

    return vendors;
  }

  anyMatchFound(match): boolean {
    let result = false;
    match.forEach((item: any) => {
      if (item.result === 'fuzzy') {
        result = true;
      }
    });
    return result;
  }

  isRemovedVendor(vendor, finalEventVendors): boolean {
    let result = true;
    finalEventVendors.forEach((item: any) => {
      if (vendor.payorType === item.payorType &&
          vendor.chain === item.chain &&
          vendor.brand === item.brand &&
          vendor.propertyId === item.propertyId) {
        result = false;
      }
    });
    return result;
  }

  removeVendorProcess(vendor: any) {
    if (vendor.payorType === 'PROPERTY' &&
        vendor.mergedEvent === 'Y') {
      this.removedVendors.push(JSON.parse(JSON.stringify(vendor)));
    }
  }

  selectedAgency() {
    this.isSelectedAgency = true;
  }
}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event/event.component.ts